export default [
  {
    path: '/foms',
    name: 'FomsRegister',
    component: () => import(/* webpackChunkName: 'BaibuStaticHtml' */ '@/views/baibu/index.vue'),
    children: [
      // 用户注册协议
      {
        path: 'registration-agreement/:type',
        name: 'FomsRegistrationAgreement',
        component: () => import(/* webpackChunkName: 'BaibuStaticHtml' */ '@/views/foms/registration-agreement.vue'),
      },
    ],
  },
];
